module.exports = require('comlink').wrap(require("!worker-loader?{}!/app/node_modules/comlink-loader/dist/comlink-worker-loader.js!/app/node_modules/babel-loader/lib/index.js!/app/node_modules/eslint-loader/index.js??ref--0!/app/src/workers/ecgfilter.worker.js")());module.exports.__esModule = true;


//////////////////
// WEBPACK FOOTER
// ./src/workers/ecgfilter.worker.js
// module id = G2Fo
// module chunks = 2